import React from "react";
import { Container } from "./styles";

function Anamnesis() {
  return <Container>Em Desenvolvimento</Container>;
}

export default Anamnesis;
